export const LEFT_SIDEBAR_STANDARD = 'standard'
export const LEFT_SIDEBAR_FRESHWORKS = 'freshworks'
export const LIONDESK = 'liondesk'
export const FRESHWORKS = 'freshworks'
export const STANDARD = 'standard'
export const CRMGROW = 'crmgrow'
